export default "__VITE_PUBLIC_ASSET__d3cf3036__"